import React from 'react';
import Navbar from './Navbar';
import StatusBar from './StatusBar';
import Terminal from './Terminal';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <StatusBar />
      <main className="flex-grow container mx-auto px-4 py-8">
        {children}
      </main>
      <Terminal />
      <Footer />
    </div>
  );
};

export default Layout;